/**
 * Safe browser environment polyfills for Node.js 22+
 * This file provides browser-like objects for server-side code
 * in a way that's compatible with Node.js 22's restrictions
 */

// Initialize browser environment utilities
(function(root, factory) {
  // Support both CommonJS and ESM environments
  if (typeof module === 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // Browser/ESM
    root.browserEnv = factory();
  }
}(typeof self !== 'undefined' ? self : this, function() {
  // Check if we're running in a browser
  const isBrowser = typeof window !== 'undefined';

  // Create a safe browser environment object
  const createBrowserEnv = () => {
    const env = {};
    
    // Window-like object
    env.window = {};
    if (isBrowser) {
      Object.assign(env.window, window);
    }
    
    // Document-like object
    if (isBrowser) {
      env.document = document;
    } else {
      env.document = {
        createElement: () => ({}),
        createTextNode: () => ({}),
        documentElement: { style: {} },
        body: {},
        querySelector: () => null,
        querySelectorAll: () => []
      };
    }
    
    // Navigator-like object
    if (isBrowser) {
      env.navigator = navigator;
    } else {
      env.navigator = { userAgent: 'node' };
    }
    
    // Define Element classes safely
    env.Element = isBrowser && typeof Element !== 'undefined' 
      ? Element 
      : class Element {};
      
    env.HTMLElement = isBrowser && typeof HTMLElement !== 'undefined' 
      ? HTMLElement 
      : class HTMLElement extends env.Element {};
    
    return env;
  };

  // Create and export the browser environment
  const browserEnv = createBrowserEnv();
  
  // Helper to safely check for browser features
  const hasBrowserFeature = (featurePath) => {
    if (!isBrowser) return false;
    
    try {
      const parts = featurePath.split('.');
      let obj = window;
      
      for (const part of parts) {
        if (obj === undefined || obj === null) return false;
        obj = obj[part];
      }
      
      return obj !== undefined && obj !== null;
    } catch (e) {
      return false;
    }
  };
  
  // If running on the server in Node.js 22+, run a safe initialization for critical polyfills
  if (!isBrowser && typeof process !== 'undefined' && process.versions && process.versions.node) {
    const majorVersion = parseInt(process.versions.node.split('.')[0], 10);
    
    if (majorVersion >= 22) {
      console.log(`Detected Node.js v${process.versions.node}, safely initializing browser environment...`);
      
      // Set up global references to our safe browser env without modifying read-only properties
      if (typeof global !== 'undefined') {
        // Use the defineProperty approach to avoid the error with read-only properties
        if (!global._browserEnv) {
          try {
            Object.defineProperty(global, '_browserEnv', {
              value: browserEnv,
              writable: true,
              configurable: true
            });
          } catch (e) {
            console.warn('Warning: Unable to define _browserEnv on global object:', e.message);
          }
        }
      }
    }
  }
  
  // Return the browser environment and utilities
  return {
    ...browserEnv,
    isBrowser,
    hasBrowserFeature
  };
}));